import React, { useState } from 'react';

const Snackbar = (props) => {
  const { store = {}} = props
  const { snackBar = {}} = store
  const { status = false , message = "", code = "" } = snackBar

  var className = "snackbar"
  if(status) className += " show"
  else className += " hide"

  return (
        <div className={className}>{message}</div>
  );
};

export default Snackbar